module.exports = __webpack_public_path__ + "59fac015094e3c9a3eacf181551b3ace.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/balloon-purple-heart-right-s.png
// module id = 1976
// module chunks = 0